import { ref } from "vue";
import { useOffsetPagination } from "@vueuse/core";
import { makeLogger } from "@/shared/consola";

const logger = makeLogger(usePagination.name);

export function usePagination({ size, initialPage = 1, fetchAction }) {
    const page = ref(initialPage);
    const pageSize = ref(size);
    const total = ref(0);
    const { pageCount } = useOffsetPagination({
        page,
        pageSize,
        total,
        onPageChange: () => {
            logger.trace("onPageChange");
            return fetchAction();
        },
        onPageSizeChange: () => {
            logger.trace("onPageSizeChange");
            return fetchAction();
        },
    });

    return {
        page,
        pageSize,
        totalPages: pageCount,
        updatePaginationUnwrapResult: async ({ result, pagination }) => {
            page.value = pagination.page;
            total.value = pagination.total;
            return result;
        },
    };
}
